<template>
    <div>
        <router-link to="/">
            <img src="@/assets/home.png" width="32px" height="32px" />
        </router-link>

        <div>
            <h4 style="    margin: 1rem;">
                Preguntas Frecuentes  Place to Pay
            </h4>            
        </div>

        <div class="accordion" id="accordionExample">
            <div class="card card-pf">
                <div class="card-header" id="headingOne">
                    <h5 class="mb-0">
                        1. ¿Qué es Place to Pay?
                    </h5>
                </div>

                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                    data-parent="#accordionExample">
                    <div class="card-body">
                        Place to Pay es la plataforma de pagos electrónicos que usa La Alcaldía de Puerto Rico – Caquetá para procesar en línea las transacciones de impuestos industria y comercio y predial.
                    </div>
                </div>
            </div>
            <div class="card card-pf">
                <div class="card-header" id="headingTwo">
                    <h5 class="mb-0">
                        2. ¿Cómo puedo pagar?
                    </h5>
                </div>
                <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordionExample">
                    <div class="card-body">
                        En el portal de pago de impuesto del municipio de Puerto Rico – Caquetá. usted podrá realizar su pago con los medios habilitados para tal fin. Usted, de acuerdo a las opciones de pago escogidas por el comercio, podrá pagar a través de PSE (débitos desde cuentas de ahorros y corrientes en Colombia), tarjetas de crédito Visa, MasterCard.
                    </div>
                </div>
            </div>
            <div class="card card-pf">
                <div class="card-header" id="headingThree">
                    <h5 class="mb-0">
                        3. ¿Es seguro ingresar mis datos bancarios en este sitio web?
                    </h5>
                </div>
                <div id="collapseThree" class="collapse show" aria-labelledby="headingThree" data-parent="#accordionExample">
                    <div class="card-body">
                        Para proteger tus datos delega en Place to Pay la captura de la información sensible. Nuestra plataforma de pagos cumple con los más altos estándares exigidos por la norma internacional PCI DSS de seguridad en transacciones con tarjeta de crédito. Además tiene certificado de seguridad SSL expedido por GeoTrust una compañía Verisign, el cual garantiza comunicaciones seguras mediante la encriptación de todos los datos hacia y desde el sitio; de esta manera te podrás sentir seguro a la hora de ingresar la información de su tarjeta.
                        Durante el proceso de pago, en el navegador se muestra el nombre de la organización autenticada, la autoridad que lo certifica y la barra de dirección cambia a color verde. Estas características son visibles de inmediato y dan garantía y confianza para completar la transacción en Place to Pay.
                        Place to Pay también cuenta con el monitoreo constante de McAfee Secure y la firma de mensajes electrónicos con Certicámara.
                    </div>
                </div>
            </div>
            <div class="card card-pf">
                <div class="card-header" id="headingThree">
                    <h5 class="mb-0">
                        4. ¿Puedo realizar el pago cualquier día y a cualquier hora?
                    </h5>
                </div>
                <div id="collapseThree" class="collapse show" aria-labelledby="headingThree" data-parent="#accordionExample">
                    <div class="card-body">
                        Sí, en el portal de pago de impuesto del municipio de Puerto Rico Caquetá, podrás realizar tus Pagos en línea los 7 días de la semana, las 24 horas del día a sólo un clic de distancia.
                    </div>
                </div>
            </div>
            <div class="card card-pf">
                <div class="card-header" id="headingThree">
                    <h5 class="mb-0">
                        5. ¿Pagar electrónicamente tiene algún valor para mí como comprador?
                    </h5>
                </div>
                <div id="collapseThree" class="collapse show" aria-labelledby="headingThree" data-parent="#accordionExample">
                    <div class="card-body">
                        No, los pagos electrónicos realizados a través de Place to Pay no generan costos adicionales para el comprador.
                    </div>
                </div>
            </div>
            <div class="card card-pf">
                <div class="card-header" id="headingThree">
                    <h5 class="mb-0">
                        6. ¿Qué debo hacer si mi transacción no concluyó?
                    </h5>
                </div>
                <div id="collapseThree" class="collapse show" aria-labelledby="headingThree" data-parent="#accordionExample">
                    <div class="card-body">
                        En primera instancia, revisar si llegó un email de confirmación de la transacción a la cuenta de correo electrónico inscrita en el momento de realizar el pago, en caso de no haberlo recibido, deberás contactar a hacienda@puertorico-caqueta.gov.co  para confirmar el estado de la transacción.
                    </div>
                </div>
            </div>
            <div class="card card-pf">
                <div class="card-header" id="headingThree">
                    <h5 class="mb-0">
                        7. ¿Qué debo hacer si no recibí el comprobante de pago?
                    </h5>
                </div>
                <div id="collapseThree" class="collapse show" aria-labelledby="headingThree" data-parent="#accordionExample">
                    <div class="card-body">
                        Por cada transacción aprobada a través de Place to Pay, recibirás un comprobante del pago con la referencia de compra en la dirección de correo electrónico que indicaste al momento de pagar.
                        Si no lo recibes, podrás contactar al correo electrónico hacienda@puertorico-caqueta.gov.co , para solicitar el reenvío del comprobante a la misma dirección de correo electrónico registrada al momento de pagar.
                    </div>
                </div>
            </div>
        </div>
        <div>
            <img src="@/assets/logoptp.svg"></img>
        </div>
    </div>
</template>

<script>

export default {
    name: "PreguntaFrecuentesPTP",
    data: function () {
        return {
        };
    },
    methods: {

    },
    async mounted() {

    }
};
</script>

<style>
    .card-pf {
        margin-bottom: 2rem;
        border-bottom: 1px solid rgba(0, 0, 0, 0.125) !important; 
    }
</style>
